module.exports = __webpack_public_path__ + "static/img/ebbly-app.cd6633c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ebbly-app.png
// module id = 0r0e
// module chunks = 33